import React from "react";

function Troubleshoot() {
  const handleOpen = () => {
    window.open(
      "https://blog.hireplusplus.com/ai-interview-guidelines-and-process/",
      "_blank",
      "noopener,noreferrer",
    );
  };
  return (
    <div className="w-[95%] lg:w-[95%] xl:w-[76%] m-auto pt-7 pb-3 xl:pb-0">
      <div
        onClick={handleOpen}
        className="font-semibold text-[1rem] inline-block pl-2 cursor-pointer underline text-[#206DC5] hover:text-blue-500 transition-all duration-200 ease-in-out"
      >
        Troubleshooting steps
      </div>
      {/* <div className="text-[#206DC5] font-bold text-[.9rem] mt-[0.15rem]">
        Browser Compatibility | Network Compatibility | Accessing Audio | Accessing Video | Screen Share 
        </div> */}
    </div>
  );
}

export default Troubleshoot;
